import { Minus, Plus } from 'lucide-react';

import { DivProps } from '../../../../../typings';
import UDText from 'ud-ui/components/text';
import { CountButton } from './styles';

interface IProps extends DivProps {
  setValue: (value: number) => void;
  value: number;
  title?: string;
  titleWidth?: number;
}

function Counter(props: IProps) {
  const { value, setValue, title, titleWidth, className = '', ...rest } = props;

  return (
    <div className={'d-flex flex-row ' + className} {...rest}>
      <div className={'d-flex'} style={{ width: titleWidth ?? 'unset' }}>
        <UDText type={'subhead'} color={'#686A79'}>
          {title && title + ':'}
        </UDText>
      </div>
      <div className={'d-flex ml-4 gap-2'}>
        <CountButton onClick={() => setValue(value - 1)} icon={<Minus size={20} />} />
        <div className={'flex-center'} style={{ width: 20 }}>
          <UDText type={'subhead'} className={'fw-700'} color={'#686A79'}>
            {value}
          </UDText>
        </div>
        <CountButton onClick={() => setValue(value + 1)} icon={<Plus size={20} />} />
      </div>
    </div>
  );
}

export default Counter;
